import { useState } from 'react'
import { Button } from '../../components/ui'

const aiToolsOptions = ['Claude', 'ChatGPT', 'Copilot', 'Whisper', 'ElevenLabs', 'Midjourney']

function TeamMemberForm({ onSubmit, onCancel, loading }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    role: 'Member',
    ai_tools: [],
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const toggleTool = (tool) => {
    setFormData(prev => ({
      ...prev,
      ai_tools: prev.ai_tools.includes(tool)
        ? prev.ai_tools.filter(item => item !== tool)
        : [...prev.ai_tools, tool],
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!formData.name || !formData.email) return
    onSubmit(formData)
  }

  return (
    <form onSubmit={handleSubmit} className="stack">
      <div className="form-group">
        <label className="form-label">Name</label>
        <input
          className="form-input"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">Email</label>
        <input
          className="form-input"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">Role</label>
        <input
          className="form-input"
          name="role"
          value={formData.role}
          onChange={handleChange}
          placeholder="Founder, Ops, Engineer"
        />
      </div>

      <div className="form-group">
        <label className="form-label">AI Tools</label>
        <div className="checkbox-grid">
          {aiToolsOptions.map(tool => (
            <label key={tool} className="checkbox-item">
              <input
                type="checkbox"
                checked={formData.ai_tools.includes(tool)}
                onChange={() => toggleTool(tool)}
              />
              <span>{tool}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="modal-actions">
        <Button type="button" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" loading={loading}>
          Save Member
        </Button>
      </div>
    </form>
  )
}

export default TeamMemberForm
